<script setup lang="ts">
import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import RadioButton from 'primevue/radiobutton';

defineProps<{
  visible: boolean;
  conflictResolutionChoice: 'origin' | 'destination';
}>();

const emit = defineEmits<{
  'update:visible': [value: boolean];
  'update:conflictResolutionChoice': [value: 'origin' | 'destination'];
  apply: [];
  cancel: [];
}>();
</script>

<template>
  <Dialog
    :visible="visible"
    modal
    header="Conflicting schedule"
    class="w-full max-w-lg"
    :draggable="false"
    :dismissable-mask="true"
    @update:visible="emit('update:visible', $event)"
  >
    <p class="mb-4 text-sm text-gpx_gray-100">
      The origin departure and destination arrival you set do not match the
      drive times from the selected routes (including breaks). Choose which
      time to keep; other stop times will be cleared and filled again from
      that anchor.
    </p>
    <div class="flex flex-col gap-3">
      <div class="flex items-center gap-2">
        <RadioButton
          :model-value="conflictResolutionChoice"
          input-id="composer-conflict-origin"
          name="wizardConflictResolution"
          value="origin"
          @update:model-value="
            emit('update:conflictResolutionChoice', $event as 'origin' | 'destination')
          "
        />
        <label class="cursor-pointer text-sm" for="composer-conflict-origin">
          Start from origin
        </label>
      </div>
      <div class="flex items-center gap-2">
        <RadioButton
          :model-value="conflictResolutionChoice"
          input-id="composer-conflict-destination"
          name="wizardConflictResolution"
          value="destination"
          @update:model-value="
            emit('update:conflictResolutionChoice', $event as 'origin' | 'destination')
          "
        />
        <label
          class="cursor-pointer text-sm"
          for="composer-conflict-destination"
        >
          Start from destination
        </label>
      </div>
    </div>
    <template #footer>
      <Button
        type="button"
        label="Cancel"
        severity="secondary"
        @click="emit('cancel')"
      />
      <Button type="button" label="Apply" @click="emit('apply')" />
    </template>
  </Dialog>
</template>
